import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./Home.module.css";

function VerifyAccount({ setUser }) {
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const storedEmail = sessionStorage.getItem("email");
  const email = storedEmail ? storedEmail.trim() : "";

  useEffect(() => {
          const token = localStorage.getItem('access_token');
          if (token) {
            navigate('/start');
            return;
          }
        }, [navigate]);

  const handleVerification = async () => {
    if (!email || !code || !password) {
      setMessage("すべてのフィールドを入力してください。");
      return;
    }

    setMessage("認証中...");

    try {
      const response = await axios.post(
        "https://api.nagae.biz/api/verify",
        { email, code: code.trim(), password: password.trim() },
        { headers: { "Content-Type": "application/json" } }
      );

      setMessage(response.data.message);
      localStorage.setItem("access_token", response.data.access_token);

      const userResponse = await axios.get("https://api.nagae.biz/api/users/me", {
        headers: { "Authorization": `Bearer ${response.data.access_token}` },
      });

      navigate("/info", { replace: true });
      setTimeout(() => setUser(userResponse.data), 100);
      
    } catch (error) {
      if (error.response && error.response.data) {
        const errorDetail = error.response.data.detail;
        if (Array.isArray(errorDetail)) {
          setMessage(errorDetail.map((err) => err.msg).join(", "));
        } else if (typeof errorDetail === "string") {
          setMessage(errorDetail);
        } else {
          setMessage("エラーが発生しました。");
        }
      } else {
        setMessage("サーバーに接続できません。");
      }
    }
  };

  return (
    <div className={styles.container}>
      <img src="" alt="背景画像" className={styles.backgroundImage} />
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>アカウント新規登録</h1>
        </header>
        <div className={styles.card}>
          <p className={styles.emailText}>登録メール: {email}</p>
          <form onSubmit={(e) => e.preventDefault()} className={styles.loginForm}>
            <div className={styles.formGroup}>
              <label>認証コード:</label>
              <input
                type="text"
                className={styles.inputField}
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="認証コード"
                required
                onKeyDown={(e) => e.key === "Enter" && handleVerification()}
              />
            </div>
            <div className={styles.formGroup}>
              <label>パスワード:</label>
              <input
                type="password"
                className={styles.inputField}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="パスワード"
                required
                onKeyDown={(e) => e.key === "Enter" && handleVerification()}
              />
            </div>
            <button onClick={handleVerification} className={`${styles.btn} ${styles.btnPrimary}`}>
              登録する
            </button>
            {message && <p className={styles.errorMessage}>{message}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default VerifyAccount;
